module.exports = __webpack_public_path__ + "static/whatsapp_icon-a17c0557e9b95beb99619c7892518572.png";